import React from 'react';
import { ClipLoader } from 'react-spinners';
import Paragraph from 'shared/components/Paragraph';

export default ({ loading, text }) => {
  return loading ? (
    <div className='login-loading-overlay'>
      <ClipLoader size={24} color='#0066B3' />
      <Paragraph size='medium'><span>{text}</span></Paragraph>
    </div>
  ) : null;
};
